import { Button, Classes, H5, HTMLTable, Popover } from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { INotaVar } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { NotaVarFcpStore } from "../../stores/vars/NotaVarFcpStore";
import { sortBy } from "../../utils";

interface NotaVarsFcpPageProps {
}

interface NotaVarsFcpPageState {
}

@observer
export class NotaVarsFcpPage
  extends React.Component<NotaVarsFcpPageProps, NotaVarsFcpPageState>
{
  componentDidMount() {
    AppStore.setTitle("Variáveis Fundo de Combate à Pobreza");
    NotaVarFcpStore.load();
  }

  handleCreate = () => {
    AppStore.setLocation("/var-fcp/create");
  };

  handleEdit(v: INotaVar) {
    AppStore.setLocation(`/var-fcp/edit/${v._id}`);
  }

  render() {
    let sorted = sortBy(NotaVarFcpStore.obs.vars_fcp, "nome");
    let items = sorted?.map(v => {
      return (
        <tr key={v._id} className="nz-table-actions">
          <td>{v.nome}</td>
          <td>{v.descricao}</td>
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEdit.bind(this, v)}
            >
              <img src="/images/edit.png" width={25} />
            </MDBBtn>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Confirmar exclusão da variável {v.nome}?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => NotaVarFcpStore.handleDelete(v._id)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <MDBRow>
          <MDBCol md="3">
            <MDBBtn className="btnDefault noFloat" onClick={this.handleCreate}>
              Criar Variável
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <div className="TableDefault">
          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%" }}
            small
          >
            <thead>
              <tr>
                <th style={{ width: 220 }}>Nome</th>
                <th>Descrição</th>
                <th style={{ width: 120 }} />
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </HTMLTable>
        </div>
        <div style={{ marginBottom: 80 }} />
      </div>
    );
  }
}

export default NotaVarsFcpPage;
